import { Grid, Alert, Link, Typography } from '@mui/material'
import { ROUTES_PATH } from 'config'
import { color } from 'config/color'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'

interface NotificationBannerProps {
    onClose: () => void
    isAuthenticated?: boolean
}

export const NotificationBanner: React.FC<NotificationBannerProps> = ({
    onClose
}: NotificationBannerProps): JSX.Element => {
    const isMobile = useMobileBreakpoints()
    return (
        <Grid container justifyContent="center">
            <Alert
                severity="warning"
                icon={false}
                onClose={onClose}
                sx={{
                    bgcolor: color.background[900],
                    color: '#FFFFFF',
                    px: { xs: 2, md: 30 },
                    py: 3,
                    width: '100%',
                    mx: 'auto',
                    textAlign: 'center',
                    borderRadius: '0px'
                }}
            >
                <Typography fontWeight="bold" marginLeft={isMobile ? '0' : '100px'}>
                    Your new WEBCare account will have limited data available before November 2024. If you need historical bills from before that period, please{' '}
                    <Link
                        sx={{ color: color.grey[100], textDecoration: 'underline' }}
                        href={ROUTES_PATH.CONTACT_US}
                    >
                        contact us
                    </Link>
                </Typography>
            </Alert>
        </Grid>
    )
}
